/**
 * Map từ RefType sang tên form chi tiết
 * Mục đích tạo file này là do 1 file Detail có thể chứa 2 reftype RefTypeMapperDetailName
 * NXCHIEN 19.05.2022
 */
export default {
  // Phiếu thu
  CAReceiptDetail: 20,
  // Phiếu chi
  CAPaymentDetail: 21,
  // Kiểm kê quỹ tiền mặt
  CAFundInventoryDetail: 22,
  // Nộp tiền Kho bạc
  BADepositDetail: 30,
  // Rút tiền Kho bạc
  BUTreasuryWithdrawalDetail: 31,
  // Chuyển tiền nội bộ
  BAInternalTransferDetail: 32,
  // Chi tiền gửi
  BAWithDrawDetail: 33,
  // Chuyển khoản kho bạc
  BUTransferDetail: 34,
  // Bảng kê nộp tiền NSNN
  BAAdvanceNSNNDetail: 35,
  // Điều chỉnh kinh phí chi
  CAAdjustPaymentDetail: 40,
  // Điều chỉnh kinh phí thu
  CAAdjustReceiptDetail: 41,
  // Đề nghị cam kết chi
  BUCommitmentRequestDetail: 42,
  // Điều chỉnh cam kết chi
  BUPlanAdjustCommitDetail: 43,
  // Dự toan giữ lại
  BUBudgetReserveDetail: 44,
  // Nhập khác
  INInwardDetail: 60,
  // Phiếu xuất kho
  INOutwardDetail: 61,
  // Nhập mua bằng tiền mặt
  InventoryInwardCashDetail: 62,
  // Nhập mua bằng tiền gửi
  InventoryInwardDepositDetail: 63,
  // Chuyển kho
  InventoryTransferDetail: 64,
  // Số dư ban đầu vật tư
  OpeningInventoryItem: 69,
  // Phiếu ghi tăng TSCĐ
  FAVoucherIncreamentDetailFixedAsset: 70,
  // Phiếu ghi giảm TSCĐ
  FAVoucherDecrementDetailFixedAsset: 71,
  // Phiếu điều chỉnh TSCĐ
  FAVoucherAdjustmentDetailFixedAsset: 72,
  // Khấu hao TSCĐ
  FAVoucherDepreciationDetailFixedAsset: 73,
  // Phiếu ghi tăng CCDC
  ToolIncrementDetail: 74,
  // Phiếu ghi giảm CCDC
  SUDecrementDetail: 75,
  // Phiếu điều chuyển CCDC
  SUTransferDetail: 77,
  // Điều chuyển phòng ban
  FixedAssetTransfer: 76,
  // Số dư ban đầu TSCĐ
  OpeningFixedAsset: 78,
  // Số dư ban đầu CCDC
  OpeningTool: 79,
  // Bảng lương
  SalarySheet: 80,
  // Hạch toán chi phí lương
  SASalaryAccountingDetail: 81,
  // Chứng từ nghiệp vụ khác
  SUGeneralVoucherDetail: 100,
  // Phiếu kết chuyển tài khoản
  SUAccountTransferDetail: [130, 132, 133, 134, 135, 136, 101],
  // Tổng hợp chứng từ cùng loại
  VoucherList: 102,
  // Tổng hợp chứng từ cùng loại detail
  SUVoucherListDetail: 102,
  // Bảng kê ghi thu - ghi chi
  BUReceiptExpenseDetail: 103,
  // Bảng kê thanh toán tạm ứng
  BUAdvancePaymentDetail: 104,
  // Bảng kê chứng từ thực chi
  BUAdvancePaymentExpenceDetail: 105,
  // Chứng từ ghi đồng thời
  ParallelVoucher: 106,
  // Số dư đầu tài khoản khác
  OpeningAccount: 109,
  // Số dư đầu mục lục ngân sách
  OpeningBudget: 110,
  // Số dư ban đầu đối tượng
  OpeningAccountingObject: 112,
  // Số dư ban đầu quỹ
  OpeningFund: 113,
  // Số dư ban đầu Hoạt động tài chính
  OpeningActivity: 114,
  // Số dư ban đầu Hoạt động tài chính và Đối tượng
  OpeningActivityAndAccountingObject: 115,
  // Số dư ban đầu tài khoản ngân hàng
  OpeningBankAccount: 116,
  // Số dư ban đầu MLNS và tài khoản ngân hàng
  OpeningBudgetAndBankAccount: 117,
  // Số dư ban đầu Quỹ và tài khoản ngân hàng
  OpeningFundAndBankAccount: 118,
  // Chứng từ ghi sổ
  RegisterVoucher: 120,
  // Chứng từ ghi sổ detail
  SURegisterListDetail: 120,
  // Bảng tổng hợp biên lai thu tiền
  ReceiptSummary: 122,
  // Kết chuyển chi ngân sách
  TranferPaymentClear: 131,
  // Kết chuyển chi ngân sách trong thời gian chỉnh lý
  TranferPaymentClearInMonth13: 137,
  // Dự toán chi theo MLNS, Bổ sung Dự toán chi theo MLNS
  BUPlanExpenseByBudgetSupplementDetail: [150, 151],
  // Điều chỉnh Dự toán chi theo MLNS
  BUPlanExpenseByBudgetSupplementAdjustDetail: 320,
  // Dự toán chi theo TT 342
  BUPlanExpenseByActivitySupplement342Detail: [322, 323],
  // Điều chỉnh Dự toán chi theo TT 342
  BUPlanExpenseByActivitySupplementAdjust342Detail: 324,
  // Dự toán chi theo TT343
  BUPlanExpenseByActivitySupplement343Detail: [325, 326],
  // Điều chỉnh Dự toán chi theo TT343
  BUPlanExpenseByActivitySupplementAdjust343Detail: 327,
  // Dự toán chi theo TT344
  BUPlanExpenseByActivitySupplement344Detail: [328, 329],
  // Điều chỉnh Dự toán chi theo TT344
  BUPlanExpenseByActivitySupplementAdjust344Detail: 330,
  // Dự toán chi theo Vũ Thư
  BUPlanExpenseByActivitySupplementVtDetail: [340, 341],
  // Điều chỉnh Dự toán chi theo Vũ Thư
  BUPlanExpenseByActivitySupplementAdjustVtDetail: 342,
  // Dự toán thu theo MLNS
  BUPlanReceiptAddMLNSDetail: [153, 152],
  // Điều chỉnh Dự toán thu theo MLNS
  BUPlanReceiptAdjustMLNSDetail: 321,
  // Dự toán thu theo TT 342
  BUPlanReceiptAddTT342Detail: [331, 332],
  // Điều chỉnh Dự toán thu theo TT 342
  BUPlanReceiptAdjustTT342Detail: 333,
  // Dự toán thu theo TT343
  BUPlanReceiptAddTT343Detail: [334, 335],
  // Điều chỉnh Dự toán thu theo TT343
  BUPlanReceiptAdjustTT343Detail: 336,
  // Dự toán thu theo TT344
  BUPlanReceiptAddTT344Detail: [337, 338],
  // Điều chỉnh Dự toán thu theo TT344
  BUPlanReceiptAdjustTT344Detail: 339,
  // Nhận dự toán đầu năm
  BUReceiveBudgetPlanDetail: [154, 155],
  // Điều chỉnh dự toán
  BUPlanAdjustmentDetail: 156,
  // Hủy dự toán
  BUPlanCancelDetail: 157,
  // Chi tiền gửi trả lương
  CashPaymentDepositSalary: 163,
  // Phiếu chi trả lương
  CashPaymentSalary: 164,
  // Chuyển khoản kho bạc vào tài khoản tiền gửi
  BUTransferDepositDetail: 165,
  // Kế hoạch vốn đầu tư xây dựng cơ bản
  BUInvestmentPlanXDCBDetail: 303,
  // Kế hoạch thu chi các hoạt động tài chính khác
  BUFinancialActivitiesDetail: 304,
  // Ghi tăng TSCĐ từ QLTS.VN
  FAVoucherIncreamentDetail: 410,
  // Điều chỉnh TSCĐ từ QLTS.VN
  FAVoucherAdjustmentDetail: 411,
  // Hao mòn TSCĐ từ QLTS.VN
  FAVoucherDepreciationDetail: 413,
  // Ghi giảm TSCĐ từ QLTS.VN
  FAVoucherDecrementDetail: 414,
  // Điều chỉnh kinh phí
  BUExpenseWithdrawAdjustmentDetail: 652,
  // Biên lai điện tử
  ElectricReceipt: 701,
  // Tổng hợp biên lai thu tiền
  EReceiptSummaryDetail: 122,

  // Chi tiền gửi trả lương
  SASalaryPaymentDetail: 123,
  // Chuyển khoản kho bạc vào tài khoản tiền gửi chi lương
  SATransferTreasuryToSalaryDepositAccount: 124,

  // Chi tiết hóa đơn
  InbotInvoiceDetail: 666,
  // Chi tiết hồ sơ
  DVCFileDetail: 667,
};
